import { Inject, Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { ISendBetArgs } from "../store/interfaces";
import { CURRENCY_TOKEN } from "@karma-games/angular-devkit/src/lib/modules/pipes";

@Injectable()
export class SendBetUseCase implements IUseCase<ISendBetArgs, Promise<void>> {
    constructor(private roundRepository: RoundRepository,
                @Inject(CURRENCY_TOKEN) private currency: string) {
    }

    async execute(data: ISendBetArgs): Promise<void> {
        try {
            await this.roundRepository.sendBet(data.amount, data.betIndex, this.currency, data.maxMultiplier);
        } catch (e) {
            throw e;
        }
    }
}
